import { render, staticRenderFns } from "./TotalMoneyField.vue?vue&type=template&id=2322b4a8&scoped=true"
import script from "./TotalMoneyField.vue?vue&type=script&lang=js"
export * from "./TotalMoneyField.vue?vue&type=script&lang=js"
import style0 from "./TotalMoneyField.vue?vue&type=style&index=0&id=2322b4a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322b4a8",
  null
  
)

export default component.exports